import gql from 'graphql-tag';
export default gql`
  query user($email: String!, $appCode: String!) {
    user(email: $email, appCode: $appCode) {
      id
      firstName
      lastName
      email
      organisation {
        id
        name
        isActive
        orgBranding {
          logo
          brandName
        }
      }
      whiteLabel {
        region
        introducerName
        enableWhiteLabel
        domains
      }
    }
  }
`;
